import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ago } from "@/lib/dates";
import { Badge, Card, ErrorText, Section } from "@/ui/kit";
import { PageHeader } from "@/ui/Shell";

interface Sys { outbox: { pending: number; lagSeconds: number }; workers: { id: string; lastBeat: string | null }[]; deadLetters: number; release: string }

export default function System() {
  const q = useQuery({ queryKey: ["system"], queryFn: () => api<Sys>("/v1/admin/system"), refetchInterval: 15_000 });
  const s = q.data;
  const healthy = s ? s.workers.length > 0 && s.outbox.lagSeconds < 120 && s.deadLetters === 0 : false;
  return (
    <>
      <PageHeader title="System health" back="/more" subtitle={s ? `Release ${s.release.slice(0, 7)}` : " "} />
      <ErrorText error={q.error} />
      {s ? (
        <>
          <Card className={healthy ? "bg-sage" : "bg-blush"}>
            <p className="text-lg font-bold">{healthy ? "Everything's running smoothly" : "Needs attention"}</p>
            <p className="text-sm">Notifications, emails and reminders are {s.outbox.lagSeconds < 120 ? "going out on time" : `delayed by ${Math.round(s.outbox.lagSeconds)}s`}.</p>
          </Card>
          <Section title="Background workers">
            <div className="grid gap-2">
              {s.workers.length ? s.workers.map((w) => (
                <Card key={w.id} className="flex items-center justify-between"><span className="font-mono text-sm">{w.id}</span><Badge tone="sage">{w.lastBeat ? ago(w.lastBeat) : "—"}</Badge></Card>
              )) : <Card className="bg-blush">No worker heartbeats — notifications are paused. The on-call alert has fired.</Card>}
            </div>
          </Section>
          <Section title="Queue">
            <Card>{s.outbox.pending} waiting · oldest {Math.round(s.outbox.lagSeconds)}s</Card>
          </Section>
          <Section title="Failed jobs">
            <Card>{s.deadLetters ? `${s.deadLetters} need a look — see the Inbox.` : "None 🎉"}</Card>
          </Section>
        </>
      ) : null}
    </>
  );
}
